//#region src/common/load-script-async.ts
function e(e, t = document) {
	return new Promise((n, r) => {
		let i = t.createElement("script");
		i.src = e, i.onload = n, i.onerror = r, t.head.appendChild(i);
	});
}
//#endregion
export { e as loadScriptAsync };
